module.exports = __webpack_public_path__ + "img/组 50.0000b1e5.png";